import { Capacitor } from '@capacitor/core';

// Google Maps JavaScript API key selection.
//
// Web (production, unchanged): the existing key is HTTP-referrer-restricted to
// the pedalxchange.com domains. That restriction is what protects the key in a
// browser, and it must stay exactly as-is — web behavior is byte-identical.
//
// Native (Capacitor iOS/Android): the WebView origin is `capacitor://localhost`,
// which can never match an HTTP-referrer allowlist, so the referrer-restricted
// key is silently rejected by Google and Places autocomplete hangs forever on
// "Loading...". A Maps *JavaScript* API key in a WebView also cannot be locked
// down by iOS bundle id (that only applies to the native Maps SDK), so the
// native key must instead be API-restricted (Maps JavaScript + Places +
// Geocoding) with a usage quota, and left without an application restriction.
//
// This selector is the ONLY place that decides which key is used; both the web
// and native code paths build the same script URL otherwise.

const WEB_MAPS_API_KEY = 'AIzaSyC8D3CzLjQWqAA7ZWJJz9aMvMtJw5cePZo';

// New key created for the native app (no HTTP-referrer restriction; API- and
// quota-restricted in Google Cloud Console). Paste the new key here.
const NATIVE_MAPS_API_KEY = 'AIzaSyDwcILKb7Ekmtk1eKdMUQEueRtAJRBSkrI';

export const getGoogleMapsApiKey = () =>
  Capacitor.isNativePlatform() ? NATIVE_MAPS_API_KEY : WEB_MAPS_API_KEY;
